import { render, staticRenderFns } from "./ReportGuestOrderTableDesktop.vue?vue&type=template&id=16d8bb04&scoped=true"
import script from "./ReportGuestOrderTableDesktop.vue?vue&type=script&lang=js"
export * from "./ReportGuestOrderTableDesktop.vue?vue&type=script&lang=js"
import style0 from "./ReportGuestOrderTableDesktop.vue?vue&type=style&index=0&id=16d8bb04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d8bb04",
  null
  
)

export default component.exports